import { useQuery } from "@tanstack/react-query";
import { PricingTrackerService } from "../services/pricing.tracker.service";
import { PRICING_ANALYTICS_QUERY_KEY } from "../constants";

export default function useGetPricingAnalytics(data: {
  from_to: {
    from: string;
    to: string;
  };
  assignedPricingPocs: string[];
  brandIds: string[];
  briefIds: string[];
  isCostCheckedByPricing?: boolean;
}) {
  const {
    data: pricingAnalytics,
    isFetching: isPricingAnalyticsFetching,
    error: pricingAnalyticsError,
  } = useQuery({
    queryKey: [
      ...PRICING_ANALYTICS_QUERY_KEY,
      data?.from_to?.from,
      data?.from_to?.to,
      data?.assignedPricingPocs,
      data?.brandIds,
      data?.briefIds,
      data?.isCostCheckedByPricing,
    ],
    queryFn: () => PricingTrackerService.getPricingAnalytics({ ...data }),
  });

  return {
    pricingAnalytics,
    isPricingAnalyticsFetching,
    pricingAnalyticsError,
  };
}
